'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertCustomBlock = undefined;

var _immutable = require('immutable');

var _draftJs = require('draft-js');

// this function is almost same as `AtomicBlockUtils.insertAtomicBlock`
// https://github.com/facebook/draft-js/blob/master/src/model/modifier/AtomicBlockUtils.js#L32
var insertCustomBlock = exports.insertCustomBlock = function insertCustomBlock(editorState, blockType) {
  var contentState = editorState.getCurrentContent();
  var selectionState = editorState.getSelection();

  var afterRemoval = _draftJs.Modifier.removeRange(contentState, selectionState, 'backward');

  var targetSelection = afterRemoval.getSelectionAfter();
  var afterSplit = _draftJs.Modifier.splitBlock(afterRemoval, targetSelection);
  var insertionTarget = afterSplit.getSelectionAfter();

  var asCustomBlock = _draftJs.Modifier.setBlockType(afterSplit, insertionTarget, blockType);

  var fragmentArray = [new _draftJs.ContentBlock({
    key: (0, _draftJs.genKey)(),
    type: blockType,
    text: '',
    characterList: (0, _immutable.List)()
  }), new _draftJs.ContentBlock({
    key: (0, _draftJs.genKey)(),
    type: 'unstyled',
    text: '',
    characterList: (0, _immutable.List)()
  })];

  var fragment = _draftJs.BlockMapBuilder.createFromArray(fragmentArray);

  var withCustomBlock = _draftJs.Modifier.replaceWithFragment(asCustomBlock, insertionTarget, fragment);

  var newContent = withCustomBlock.merge({
    selectionBefore: selectionState,
    selectionAfter: withCustomBlock.getSelectionAfter().set('hasFocus', true)
  });

  return _draftJs.EditorState.push(editorState, newContent, 'insert-fragment');
};